import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
// import Phone, { isValidPhoneNumber } from 'react-phone-number-input';

// Components
import Step from '../Common/Step';
import EnrollIntro from './EnrollIntro';
import EnrollPhone from './EnrollPhone';
import EnrollSMS from './EnrollSMS';
import EnrollPC from './EnrollPC';
import EnrollSettings from './EnrollSettings';
import EnrollComplete from './EnrollComplete';

const StudentEnrollment = observer(class StudentEnrollment extends React.Component {
  constructor() {
    super();
    this.setStep = this.setStep.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.setDisplayStep = this.setDisplayStep.bind(this);
  }

  componentWillMount() {
    this.state = {
      step: 1,
      displayStep: 1,
      textPhone: null,
      showTextForm: false,
      textFormSent: false,
      recordingSupport: navigator.getUserMedia,
      voiceRecording: null,
      hasRecorded: false,
      showVoicePhone: false
    }
  }

  setStep(e, step) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step
    });
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  setDisplayStep(displayStep) {
    this.setState({
      displayStep
    })
  }

  isActive(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  render() {
    const { translation } = this.props;
    let steps = translation.steps;

    if(this.props.smarterID) {
      steps = translation.sid_steps;
    }

    return (
      <main tabIndex="0" id="main-content" className="page wrap">
        <div className="page--brief">
          <Step step={this.state.displayStep} setStep={this.setStep} data={steps} skippable={false} />
        </div>

        <div className="slide-wrap">
          <EnrollIntro
            {...this.props}
            isActive={this.isActive(1)}
            nextStep={this.nextStep}
            setStep={this.setStep}
            setDisplayStep={this.setDisplayStep}
          />

          <EnrollPhone
            {...this.props}
            isActive={this.isActive(2)}
            setStep={this.setStep}
            setDisplayStep={this.setDisplayStep}
          />

          <EnrollSMS
            {...this.props}
            isActive={this.isActive(3)}
            setStep={this.setStep}
            setDisplayStep={this.setDisplayStep}
          />

          <EnrollPC
            {...this.props}
            isActive={this.isActive(4)}
            setStep={this.setStep}
            setDisplayStep={this.setDisplayStep}
          />

          <EnrollSettings
            {...this.props}
            isActive={this.isActive(5)}
            setStep={this.setStep}
            setDisplayStep={this.setDisplayStep}
          />

          <EnrollComplete
            {...this.props}
            isActive={this.isActive(6)}
          />
        </div>
      </main>
    );
  }
})

export default translate('StudentEnrollment')(StudentEnrollment);


// WEBPACK FOOTER //
// ./src/app/components/Enroll/StudentEnrollment.js